import { useFilter } from './Filter.h'

import { Fragment } from 'react'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

export default function Filter() {
    const {
        chips,
        chipLabel,
        selectChoice,
        isActive,

        filterQuery,
        setFilterQuery,

        anchor,
        setAnchor,
    } = useFilter()

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            overflow: 'auto',
            height: 50,
            gap: 1,
            px: 2
        }}>
            {chips.map((chip, i) =>
                <Fragment key={i}>
                    <Chip
                        label={chipLabel(chip)}
                        onClick={chip.choices
                            ? e => setAnchor([e.currentTarget, chip.param])
                            : () => selectChoice(chip)
                        }
                        color={isActive(chip) ? 'primary' : 'default'}
                        onDelete={isActive(chip) && chip.param !== ''
                            ? () => setFilterQuery(prev => {
                                const next = { ...prev }
                                delete next[chip.param]
                                return next
                            })
                            : undefined
                        }
                    />
                    {chip.choices &&
                        <Menu
                            anchorEl={anchor[0]}
                            open={anchor[1] === chip.param}
                            onClose={() => setAnchor([null, null])}
                        >
                            {chip.choices.map((choice, j) =>
                                <MenuItem
                                    key={j}
                                    selected={filterQuery[chip.param] === choice.key}
                                    onClick={() => selectChoice(chip, choice)}
                                >{choice.value}</MenuItem>
                            )}
                        </Menu>
                    }
                </Fragment>
            )}
        </Box>
    )
}